import { AiFieldSuggestion } from "./types";

interface AiFieldComparisonProps {
  label: string;
  suggestion: AiFieldSuggestion;
  showCharacterCount?: boolean;
  onChange: (value: string) => void;
  onUseSuggestion: () => void;
  onKeepOriginal: () => void;
}

export default function AiFieldComparison({
  label,
  suggestion,
  showCharacterCount,
  onChange,
  onUseSuggestion,
  onKeepOriginal,
}: AiFieldComparisonProps) {
  const difference = suggestion.suggestedValue.length - suggestion.originalValue.length;

  return (
    <section className="ai-field-comparison">
      <div className="ai-field-comparison__heading">
        <h4>{label}</h4>
        {suggestion.decision && (
          <span className="ai-field-decision">
            {suggestion.decision === "suggestion" ? "Suggestion selected" : "Original kept"}
          </span>
        )}
      </div>
      <div className="ai-field-comparison__columns">
        <div>
          <label>Original</label>
          <textarea value={suggestion.originalValue} rows={4} readOnly />
          {showCharacterCount && <small>{suggestion.originalValue.length} characters</small>}
        </div>
        <div>
          <label htmlFor={`ai-suggestion-${suggestion.fieldName}`}>Suggested</label>
          <textarea
            id={`ai-suggestion-${suggestion.fieldName}`}
            value={suggestion.suggestedValue}
            rows={4}
            onChange={(event) => onChange(event.target.value)}
          />
          {showCharacterCount && (
            <small>
              {suggestion.suggestedValue.length} characters ({difference >= 0 ? "+" : ""}{difference})
            </small>
          )}
        </div>
      </div>
      <div className="ai-field-comparison__actions">
        <button type="button" className="secondary-button" onClick={onKeepOriginal}>Keep original</button>
        <button type="button" className="action-button" onClick={onUseSuggestion}>Use suggestion</button>
      </div>
    </section>
  );
}
